// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"18431": "b80904821cf5","20477": "187c0583f749","37393": "7c8f92cd5f84","5856": "0308423753f6","66863": "c939bdd77392","89990": "7c4f71293c6d",}[chunkId] + ".css"
}